export const detectMob = () => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];
  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};

export const isIOSDevice =
  !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

export const isMobileSafari = /^((?!chrome|android).)*safari/i.test(
  navigator.userAgent,
);

/**
 * Get video duration from a video URL
 * @param {string} videoUrl - The URL of the video
 * @returns {Promise<number|null>} - Duration in seconds or null if error
 */
export const getVideoDuration = (videoUrl) => {
  return new Promise((resolve) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = videoUrl;
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      resolve(video.duration); // duration in seconds
    };
    // fallback in case of error
    video.onerror = () => resolve(null);
  });
};

/**
 * Format seconds to HH:MM:SS format
 * @param {number} seconds - Duration in seconds
 * @returns {string} - Formatted time string
 */
export const formatSecondsToHMS = (seconds) => {
  if (!seconds || Number.isNaN(seconds)) return "00:00:00";
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  return [h, m, s]
    .map(unit => String(unit).padStart(2, '0'))
    .join(':');
};

/**
 * Remove border class from all images that are nearest children of cursor-pointer class
 */
export const removeBordersFromCursorPointerImages = () => {
  const borderedImages = document.querySelectorAll('img.bordered');
  borderedImages.forEach(img => {
    // Check if the nearest parent with 'cursor-pointer' class exists
    let parent = img.parentElement;
    while (parent) {
      if (parent.classList && parent.classList.contains('cursor-pointer')) {
        img.classList.remove('bordered');
        break;
      }
      parent = parent.parentElement;
    }
  });
};
